import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

export type notificationStateType = {
  unreadCount: number;
};

const initialState: notificationStateType = {
  unreadCount: 0
};

export const notificationStateSlice = createSlice({
  name: 'notificationStateSlice',
  initialState,
  reducers: {
    // payload: the absolute unread count (number)
    setUnreadCount: (state, action) => {
      state.unreadCount = Math.max(0, Number(action.payload) || 0);
      return state;
    },
    incrementUnread: state => {
      state.unreadCount = state.unreadCount + 1;
      return state;
    },
    decrementUnread: state => {
      state.unreadCount = Math.max(0, state.unreadCount - 1);
      return state;
    },
    resetUnread: () => {
      return initialState;
    }
  }
});

export const { setUnreadCount, incrementUnread, decrementUnread, resetUnread } =
  notificationStateSlice.actions;

export const getUnreadCount = (state: RootState) =>
  state.notificationStateSlice?.unreadCount ?? 0;
